import React from 'react';
import styles from './styles.css';
import {observer} from 'mobx-react';

function NotAuthenticated() {
  return (
    <div className={styles.notAuthenticated}>
      <h1>Logged in</h1>
      <p>Please stand in line while we authenticate you</p>
      <i className="material-icons">group</i>
    </div>
  );
}

export default observer(NotAuthenticated);



// WEBPACK FOOTER //
// ./src/views/NotAuthenticated/NotAuthenticated.js